export default "__VITE_ASSET__CRQO4Njt__"